import React from 'react';
import { useTranslation } from 'react-i18next';
import LavvaDetailsWrapper from '../../../../../components/details-wrapper';
import { useBackdropContext } from '../../../../../context/backdrop';
import { ChannelType } from '../../../types';
import { OptimizerConfiguration } from './configuration';
import { Preview } from './configuration/components/preview';
import OptimizerConfigurationProvider from './context/configuration-context';
import { OptimizerCurrent } from './current';
import { useOptimizerCurrent } from './hooks/use-optimizer-current';
import { OptimizerMeasurements } from './measurements';

type ChannelDetailsOptimizerProps = {
  channel: ChannelType;
};

const ChannelDetailsOptimizer: React.FC<ChannelDetailsOptimizerProps> = ({ channel }) => {
  const { t } = useTranslation('channel-details');
  const { carouselDisabled } = useBackdropContext();
  const { optimizerData, workMode, temperature, measurementFullData } = useOptimizerCurrent({
    channel,
  });

  return (
    <LavvaDetailsWrapper
      preventSwipeEvent={carouselDisabled}
      tabs={[{ label: t('currently') }, { label: t('details') }, { label: t('configuration') }]}
      additionalTabs={[
        <OptimizerMeasurements key={1} channelId={channel.id} measurementFullData={measurementFullData} />,
        <OptimizerConfigurationProvider key={2}>
          <OptimizerConfiguration temperature={temperature} />
        </OptimizerConfigurationProvider>,
      ]}
      underTabs={{ component: <Preview optimizerData={optimizerData} />, index: 2 }}
    >
      <OptimizerCurrent optimizerData={optimizerData} workMode={workMode} temperature={temperature} />
    </LavvaDetailsWrapper>
  );
};

export default ChannelDetailsOptimizer;
